define('ua/listeners/search',['ua/ua-wrapper'], function(ua) {
    'use strict';

    /**
     * EVENTS:
     *  search.submit
     *  search.map.property.click
     *  search.map.zoom
     *  search.map.move
     *
     */
    function setupListeners(edap) {
        var adl = edap.getDL();

        edap.on('search.submit', function(data, setAsync, done) {
            var label,
                opts = {};

            setAsync();

            // custom metric 3
            opts[ua.metricName(3)] = 1;

            label = data.searchterm || data.geonode || data.keyword;

            ua.sendEvent(
                'search',
                'onsite search',
                label,
                undefined,
                opts,
                data
            ).then(done);
        });

        if (adl.pagetype === 'search') {
            edap.on('search.map.property.click', function(data, setAsync, done) {
                setAsync();

                ua.sendEvent(
                    'pdp preview',
                    'click',
                    data.eventlistingids,
                    undefined,
                    undefined,
                    data
                ).then(done);
            });

            edap.on('search.map.zoom', function(data, setAsync, done) {
                var label;

                setAsync();

                label = 'zoom ' + (data.zoomtype);

                ua.sendEvent(
                    'search',
                    'map',
                    label,
                    undefined,
                    undefined,
                    data
                ).then(done);
            });

            edap.on('search.map.move', function(data, setAsync, done) {
                setAsync();

                ua.sendEvent(
                    'search',
                    'map',
                    'move',
                    undefined,
                    undefined,
                    data
                ).then(done);
            });
        }
    }

    return {
        setupListeners: setupListeners
    };
});

